<app-main-dialog (dismiss)="dismiss()">
  <div desktopTitle>
    {{ titleS() }}
  </div>
  <div [innerHTML]="textS() | translate"
    class="ion-padding"></div>
  @if (hasInputS().length > 0) {
    <ion-item lines="none">
      <ion-input [placeholder]="hasInputS()"
        [(ngModel)]="inputValue"></ion-input>
    </ion-item>
  }
  <div class="flex ion-margin">
    @for (button of buttonsS(); track button; let i = $index) {
      <div>
        <ion-button color="light"
          shape="round"
          (click)="select(i)">
          {{ button | translate }}
        </ion-button>
      </div>
    }
  </div>
</app-main-dialog>